// export const backendUrl = 'http://192.168.0.24:5056/api/v1/'
export const backendUrl = 'https://api.telephony.flexz.ai/api/v1/'
// export const backendUrl = 'http://192.168.0.43:5056/api/v1/'


